<div [formGroup]="form">
  <mat-expansion-panel *ngFor="let controlName of controlNames"
                       [expanded]="true">
    <mat-expansion-panel-header [collapsedHeight]="'fit-content'">
      <div class="row w-100">
        <div class="col__">
          <h3>{{getLabel(controlName)}}</h3>
        </div>
        <div class="col__">

        </div>
      </div>

    </mat-expansion-panel-header>

    <ng-container>
      <ng-container *ngIf="isNameInput(controlName)">

        <app-name-form [entityType]="entityType"
                       [formControl]="form.get(controlName)">
        </app-name-form>

      </ng-container>

      <!-- DOB Input-->
      <ng-container *ngIf="isDemographicsInput(controlName)">
        <p>DOB Input</p>
        <app-dob-form [showDOB]="true"
                      [formControl]="form.get(controlName)">
        </app-dob-form>
      </ng-container>

      <!-- Language Input -->
      <ng-container *ngIf="isLanguageAttribute(controlName)">
        <app-language-form [formControl]="form.get(controlName)"
                           class="mt-0050">
        </app-language-form>
      </ng-container>


      <!-- Tag Category Input-->
      <ng-container *ngIf="isTagCategoryInput(controlName)">
        <div class="row  w-100 flexWrap--nowrap mt-0050">
          <div class="col col--gutter--3">
            <ng-container *ngIf="isMultiselectTagCategory(controlName)">
              <div class="mb-0050">
                <div class="row flexWrap--nowrap row--sep-if-stacked">
                  <app-apply-tag-multi-form class="col"
                                            [autoFocusDisabled]="true"
                                            [campaignId]="campaignId"
                                            [tagCategory]="getTagCategory(controlName)"
                                            [formArray]="form.get(controlName)"></app-apply-tag-multi-form>
                </div>
              </div>
            </ng-container>


            <ng-container *ngIf="isSingleSelectTagCategory(controlName)">
              <div class="mb-0050">
                <ng-container *ngFor="let control of form.get(controlName).controls; index as i">
                  <div class="row flexWrap--nowrap row--sep-if-stacked">
                    <app-apply-tag-form [campaignId]="campaignId"
                                        [autoFocusDisabled]="true"
                                        class="col"
                                        [required]="false"
                                        [tagCategory]="getTagCategory(controlName)"
                                        [formControl]="control">

                    </app-apply-tag-form>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>

          <div class="col col--gutterBtn right txt-18 color--gray">
            <button mat-icon-button
                    aria-label="Reset Response"
                    (click)="form.get(controlName).reset()">
              <mat-icon fontSet="fal"
                        fontIcon="fa-trash-alt">
              </mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
      <!-- /Tag Category Input-->

      <!-- Global Note Input-->
      <ng-container *ngIf="isGlobalNoteInput(controlName)">
        <hr>
        <div class="row  w-100 flexWrap--nowrap mt-0050">
          <mat-form-field class="col__">
            <mat-label>Note Text...</mat-label>
            <textarea matInput
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="3"
                      cdkAutosizeMaxRows="8"
                      [formControlName]="controlName"
                      data-test-id="noteInput"></textarea>
          </mat-form-field>
        </div>
      </ng-container>
      <!-- Global Note Input-->
    </ng-container>

    <app-create-connection-form *ngIf="isConnectionInput(controlName)"
                                [formControlName]="controlName"
                                [campaignId]="campaignId"
                                [fromEntityTypeId]="entityType.id"
                                [entityConnectionType]="getEntityConnectionType(controlName)"
                                class="d-block mt-0050">
    </app-create-connection-form>
  </mat-expansion-panel>
</div>
